import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../../redux/reducers/building_component/componentReducer";
import * as utils from "../../../redux/reducers/utils";

export const resetLeantoStoragePrice = (state, leanType) => {
	const { params, const_var } = state;

	if (leanType == "frontLean" && params.add_front_lean && params.add_storage_check_front) {
		const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
	}
	if (leanType == "leftLean" && params.add_left_lean && params.add_storage_check) {
		const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
	}
	if (leanType == "rightLean" && params.add_right_lean && params.add_storage_check_right) {
		const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
	}
	if (leanType == "backLean" && params.add_back_lean && params.add_storage_check_back) {
		const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
	}
};

export const removeStorage = (state) => {
	const { params, const_var } = state;

	params.nostorage = !params.nostorage;
	if (params.nostorage == true) {
		params.activeWall = "c_b_f_w";
		if (state.isFullyEnclosedChecked == true) {
			params.p_b_w = params.p_l_w = params.p_r_w = "Close";
			params.p_u_c = false;
			params.cB_addStorage_check_right = false;
			params.cB_addStorage_check_left = false;
			params.cB_addStorage_check_both = false;
			params.cB_addStorage_check_both_with_back = false;
		} else {
			if (params.p_u_c == true) {
				params.p_b_w = "Open";
				params.p_u_c = false;
			}
			if (params.cB_addStorage_check_front == true) {
				params.p_f_w = "Open";
				params.cB_addStorage_check_front = false;
			}
			if (params.cB_addStorage_check_left == true) {
				params.p_l_w = "Open";
				params.cB_addStorage_check_left = false;
			}
			if (params.cB_addStorage_check_right == true) {
				params.p_r_w = "Open";
				params.cB_addStorage_check_right = false;
			}
			params.cB_addStorage_check_both = false;
			params.cB_addStorage_check_both_with_back = false;
		}
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		const_var.UpdatedPriceData.insulation_price = undefined;
		if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
		params.noStorageCertificatePriceChange = true;
		const compRemoveWalls = ["c_b_r_s_f_w", "c_b_r_s_b_w", "c_b_r_s_l_w", "c_b_l_s_f_w", "c_b_l_s_b_w", "c_b_l_s_r_w", "c_b_f_s_w", "c_b_l_s_w", "c_b_r_s_w"];
		if (params.p_b_w != "Close") compRemoveWalls.push("c_b_b_w");
		if (params.p_l_w != "Close") compRemoveWalls.push("c_b_l_w");
		if (params.p_r_w != "Close") compRemoveWalls.push("c_b_r_w");
		cuBuilding.cP();
	}
	cuBuilding.BuildingUpdate(false, "utilitywallRight");
};

export const handleAddUtilityCheckboxChange = (state) => {
	const { params, const_var } = state;

	if (state.params.p_u_c) {
		state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		state.isFullyEnclosedChecked = false;
		state.params.p_u_f_w = "Close";
		state.params.p_f_w = "Open";
		state.params.p_f_w_f = state.params.p_f_w;
		state.params.p_b_w = "Open";
		const_var.UpdatedPriceData.utility_price_changed = true;
		if ((params.p_r_s == "4" || params.p_r_s == "5") && params.p_b_t == "2") {
			state.params.p_l_w = "1";
			state.params.p_r_w = "1";
		} else {
			state.params.p_l_w = "Open";
			state.params.p_r_w = "Open";
		}
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
	} else {
		state.params.p_u_f_w = "Open";
		state.params.p_f_w = "Open";
		state.params.p_b_w = "Open";
		state.params.p_l_w = "Open";
		state.params.p_r_w = "Open";
		state.params.p_f_w_f = state.params.p_f_w;
	}
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	cuBuilding.BuildingUpdate(true, "utilitywall");
	cuBuilding.cP();
};

export const handleUtilityLenghtSelectonChangeValue = (str, e, state) => {
	const { params, const_var } = state;

	const_var.UpdatedPriceData.insulation_price = undefined;
	if (str == "front") {
		if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) && parseInt(params.add_storage_front) > parseInt(e.target.value) && state.params.prev_p_b_c_b_f_f) {
			state.params.p_b_c_b_f_f = state.params.prev_p_b_c_b_f_f;
		}
		state.params.add_storage_front = e.target.value;
		cuBuilding.UpdateFrontLean("walls");
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;

		utils.update26GAUpgradePrice("front");
	}
	if (str == "back") {
		if (params.leftLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) && parseInt(params.add_storage_back) > parseInt(e.target.value) && state.params.prev_p_b_c_b_b_f) {
			state.params.p_b_c_b_b_f = state.params.prev_p_b_c_b_b_f;
		}
		state.params.add_storage_back = e.target.value;
		cuBuilding.UpdateBackLean("walls");
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;

		utils.update26GAUpgradePrice("back");
	}
	if (str == "left") {
		if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage) && parseInt(params.add_storage) > parseInt(e.target.value) && state.params.prev_p_b_c_b_l_f) {
			state.params.p_b_c_b_l_f = state.params.prev_p_b_c_b_l_f;
		}
		state.params.add_storage = e.target.value;
		cuBuilding.UpdateLeftLean("walls");
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;

		utils.update26GAUpgradePrice("left");
	}
	if (str == "right") {
		if (params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right) && parseInt(params.add_storage_right) > parseInt(e.target.value) && state.params.prev_p_b_c_b_r_f) {
			state.params.p_b_c_b_r_f = state.params.prev_p_b_c_b_r_f;
		}
		state.params.add_storage_right = e.target.value;
		cuBuilding.UpdateRightLean("walls");
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
		utils.update26GAUpgradePrice("right");
	}
	if (str == "center") {
		if (params.endStoragePositionZ === params.p_d - parseInt(params.p_u_t) && parseInt(params.p_u_t) > parseInt(e.target.value) && state.params.prev_p_f_w) {
			state.params.p_f_w = state.params.prev_p_f_w;
		}
		state.params.p_u_t = e.target.value;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		cuBuilding.BuildingUpdate(true, "utilitywall");
		utils.update26GAUpgradePrice();
		cuBuilding.cP();
	}
	if (str == "centerRight") {
		const_var.UpdatedPriceData.insulation_price_changed = true;
		state.params.cB_addStorage_right = e.target.value;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		cuBuilding.BuildingUpdate(true, "utilitywallRight");
		utils.update26GAUpgradePrice();
		cuBuilding.cP();
	}
	if (str == "centerRightUtility") {
		const_var.UpdatedPriceData.insulation_price_changed = true;
		state.params.cB_addStorage_right_utility = e.target.value;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		cuBuilding.BuildingUpdate(true, "utilitywallRightU");
		utils.update26GAUpgradePrice();
		cuBuilding.cP();
	}
	if (str == "centerLeft") {
		const_var.UpdatedPriceData.insulation_price_changed = true;
		state.params.cB_addStorage_left = e.target.value;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		cuBuilding.BuildingUpdate(true, "utilitywallLeft");
		utils.update26GAUpgradePrice();
		cuBuilding.cP();
	}
	if (str == "centerLeftUtility") {
		const_var.UpdatedPriceData.insulation_price_changed = true;
		state.params.cB_addStorage_left_utility = e.target.value;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		cuBuilding.BuildingUpdate(true, "utilitywallLeftUtility");
		utils.update26GAUpgradePrice();
		cuBuilding.cP();
	}
};

export const addStorage = (state, lean, lengthChange = false) => {
	const { params, const_var } = state;
	let renderData = "";

	if (lean == "left") {
		if (!lengthChange) {
			state.params.add_storage_check = !state.params.add_storage_check;
		}
		state.params.add_storage_check_1 = state.params.add_storage_check;
		if (params.add_storage_check == false && parseInt(params.lean_p_d) == parseInt(params.leftLeanStoragePosition) + parseInt(params.add_storage)) {
			params.p_b_c_b_l_f = "Open";
		}
		params.add_storage = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
		params.leftLeanStoragePosition = 0;
		const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		if (params.add_storage_check == true) {
			if (params.leanStyle.left === "standard") {
				params.p_b_c_b_l_b = "Close";
			} else {
				if (params.p_l_w != "Close") params.p_b_c_b_l_b = "Close";
				else params.p_b_c_b_l_b = "Open";
			}
		} else {
			params.p_b_c_b_l_b == "Close" ? (params.p_b_c_b_l_b = "Open") : (params.p_b_c_b_l_b = params.p_b_c_b_l_b);
		}
		if (state.isFullyEnclosedCheckedForLeftLeanTo) {
			const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
			if (params.leanStyle.left === "standard") {
				params.p_b_c_b_l_b = "Close";
			} else {
				if (params.p_l_w != "Close") params.p_b_c_b_l_b = "Close";
				else params.p_b_c_b_l_b = "Open";
			}
		}
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		if (params.insulation.leftLean.fullBuilding || params.insulation.leftLean.custom) const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
		state.params.add_storage =
			Math.floor((params.lean_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		renderData = state.params.add_storage_check + state.isFullyEnclosedCheckedForLeftLeanTo + params.add_storage + state.params.p_c_a_l_l_w + "leftLeanto";

		cuBuilding.UpdateLeftLean("walls");
		const_var.wallSelection.centerBuildingWall = "c_b_f_w";
		const_var.wallSelection.leanToWall = "select";
		params.activeWall = "c_b_f_w";
		const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		cuComponent.cameraFocusOnWall("c_b_f_w");
	}

	if (lean == "right") {
		if (!lengthChange) {
			state.params.add_storage_check_right = !state.params.add_storage_check_right;
		}
		state.params.add_storage_check_right_1 = state.params.add_storage_check_right;
		if (params.add_storage_check_right == false && parseInt(params.leanR_p_d) == parseInt(params.rightLeanStoragePosition) + parseInt(params.add_storage_right)) {
			params.p_b_c_b_r_f = "Open";
		}
		params.add_storage_right = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
		params.rightLeanStoragePosition = 0;
		const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		if (params.add_storage_check_right == true) {
			if (params.leanStyle.right === "standard") {
				params.p_b_c_b_r_b = "Close";
			} else {
				if (params.p_r_w != "Close") params.p_b_c_b_r_b = "Close";
				else params.p_b_c_b_r_b = "Open";
			}
		} else {
			params.p_b_c_b_r_b == "Close" ? (params.p_b_c_b_r_b = "Open") : (params.p_b_c_b_r_b = params.p_b_c_b_r_b);
		}
		if (state.isFullyEnclosedCheckedForRightLeanTo) {
			const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
			if (params.leanStyle.right === "standard") {
				params.p_b_c_b_r_b = "Close";
			} else {
				if (params.p_r_w != "Close") params.p_b_c_b_r_b = "Close";
				else params.p_b_c_b_r_b = "Open";
			}
		}
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		if (params.insulation.rightLean.fullBuilding || params.insulation.rightLean.custom) const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
		state.params.add_storage_right =
			Math.floor((params.leanR_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		renderData = state.params.add_storage_check_right + state.isFullyEnclosedCheckedForRightLeanTo + params.add_storage_right + state.params.p_c_a_r_l_w + "rightLeanto";

		const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		cuBuilding.UpdateRightLean("walls");
		const_var.wallSelection.centerBuildingWall = "c_b_f_w";
		const_var.wallSelection.leanToWall = "select";
		params.activeWall = "c_b_f_w";
		cuComponent.cameraFocusOnWall("c_b_f_w");
	}

	if (lean == "back") {
		if (!lengthChange) {
			state.params.add_storage_check_back = !state.params.add_storage_check_back;
		}
		state.params.add_storage_check_back_1 = state.params.add_storage_check_back;
		if (params.add_storage_check_back == false && params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) {
			params.p_b_c_b_b_f = "Open";
		}
		params.add_storage_back = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
		params.backLeanStoragePosition = 0;
		const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;

		params.add_storage_check_back == true ? (params.p_b_c_b_b_b = "Close") : params.p_b_c_b_b_b == "Close" ? (params.p_b_c_b_b_b = "Open") : (params.p_b_c_b_b_b = params.p_b_c_b_b_b);

		const is_GableLeanBackWall = state.params.leanStyle.back !== "gable" || (state.params.leanStyle.back === "gable" && state.params.p_b_w !== "Close");
		params.add_storage_check_back == true && is_GableLeanBackWall ? (params.p_b_c_b_b_b = "Close") : (params.p_b_c_b_b_b = "Open");

		if (state.isFullyEnclosedCheckedForBackLeanTo) {
			const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
			params.p_b_c_b_b_b = "Close";
		}

		const_var.UpdatedPriceData.insulation_price_changed = true;
		if (params.insulation.backLean.fullBuilding || params.insulation.backLean.custom) const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
		state.params.add_storage_back =
			Math.floor((params.leanB_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		renderData = state.params.add_storage_check_back + state.isFullyEnclosedCheckedForBackLeanTo + params.add_storage_back + state.params.p_c_a_b_l_w + "backLeanto";
		const_var.wallSelection.centerBuildingWall = "c_b_f_w";
		const_var.wallSelection.leanToWall = "select";
		params.activeWall = "c_b_f_w";
		const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		cuBuilding.UpdateBackLean("walls");
		cuComponent.cameraFocusOnWall("c_b_f_w");
	}

	if (lean == "front") {
		if (!lengthChange) {
			state.params.add_storage_check_front = !state.params.add_storage_check_front;
		}
		state.params.add_storage_check_front_1 = state.params.add_storage_check_front;
		if (params.add_storage_check_front == false && params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) {
			params.p_b_c_b_f_f = "Open";
		}
		params.add_storage_front = const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1;
		params.frontLeanStoragePosition = 0;
		const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.color_price_changed = true;
		const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		params.add_storage_check_front == true ? (params.p_b_c_b_f_b = "Close") : params.p_b_c_b_f_b == "Close" ? (params.p_b_c_b_f_b = "Open") : (params.p_b_c_b_f_b = params.p_b_c_b_f_b);

		const is_GableLeanBackWall = state.params.leanStyle.front !== "gable" || (state.params.leanStyle.front === "gable" && state.params.p_f_w !== "Close");

		params.add_storage_check_front == true && is_GableLeanBackWall ? (params.p_b_c_b_f_b = "Close") : (params.p_b_c_b_f_b = "Open");
		if (state.isFullyEnclosedCheckedForFrontLeanTo) {
			const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
			params.p_b_c_b_f_b = "Close";
		}
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
		if (params.insulation.frontLean.fullBuilding || params.insulation.frontLean.custom) const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
		state.params.add_storage_front =
			Math.floor((params.leanF_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		renderData = state.params.add_storage_check_front + state.isFullyEnclosedCheckedForFrontLeanTo + params.add_storage_front + state.params.p_c_a_f_l_w + "frontLeanto";
		const_var.wallSelection.centerBuildingWall = "c_b_f_w";
		const_var.wallSelection.leanToWall = "select";
		params.activeWall = "c_b_f_w";
		const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		cuBuilding.UpdateFrontLean("walls");
		cuComponent.cameraFocusOnWall("c_b_f_w");
	}

	return renderData;
};

const utilityStorageOptionsHelpers = {
	resetLeanToStoragePrice: resetLeantoStoragePrice,
	clearCenterStorage: removeStorage,
	applyCenterUtilityCheckbox: handleAddUtilityCheckboxChange,
	applyUtilityLengthChange: handleUtilityLenghtSelectonChangeValue,
	toggleLeanToStorage: addStorage
};

export default utilityStorageOptionsHelpers;
